import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Wrench, Calendar, ClipboardList, Settings, LogOut, ArrowRight } from 'lucide-react';

const FEATURES = [
  { icon: Calendar, title: 'Agenda Técnica', description: 'Instalaciones, mantenimientos, retiradas e incidencias del día', to: '/tecnico/agenda' },
  { icon: ClipboardList, title: 'Órdenes de Trabajo', description: 'Instalaciones definitivas y retiradas pendientes', to: '/tecnico/agenda' },
  { icon: Settings, title: 'Documentación', description: 'Actas oficiales: prueba, instalación, retirada y mantenimiento', to: '/comercial/documentacion' },
];

export default function TecnicoHome() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-[#030303] flex flex-col" data-testid="tecnico-home">
      <header className="border-b border-white/[0.06] px-6 py-4 flex items-center justify-between">
        <img src="/manklar-logo-white.png" alt="Manklar" className="h-8" />
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 px-4 py-2 rounded-xl text-zinc-400 hover:text-red-400 hover:bg-red-500/10 transition-all text-sm"
          data-testid="tecnico-logout-btn"
        >
          <LogOut className="w-4 h-4" />
          Cerrar Sesión
        </button>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center px-4 py-12">
        <div className="w-20 h-20 rounded-2xl bg-sky-500/10 border border-sky-500/20 flex items-center justify-center mb-6">
          <Wrench className="w-10 h-10 text-sky-400" />
        </div>
        <span className="text-[10px] tracking-[0.25em] uppercase text-zinc-600 font-medium font-['Manrope'] mb-2">
          Portal Técnico
        </span>
        <h1 className="text-3xl font-light text-white font-['Outfit'] mb-3 text-center">
          {user?.name ? `Hola, ${user.name}` : 'Portal Técnico'}
        </h1>
        <p className="text-zinc-400 max-w-md text-center mb-10 font-['Manrope']">
          Tu operativa diaria: agenda, órdenes de trabajo y documentación oficial in situ.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl w-full">
          {FEATURES.map((f) => (
            <button
              key={f.title}
              onClick={() => navigate(f.to)}
              className="p-6 rounded-2xl bg-white/[0.02] border border-white/[0.07] text-left hover:border-sky-500/40 hover:bg-sky-500/[0.04] transition-all group"
              data-testid={`tecnico-card-${f.title.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <f.icon className="w-6 h-6 text-sky-400 mb-3" />
              <p className="text-sm text-white font-medium mb-1 flex items-center gap-1.5">
                {f.title}
                <ArrowRight className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
              </p>
              <p className="text-xs text-zinc-500">{f.description}</p>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}
